import AddressEditor from '../../../AddressEditor';
import addressFieldsConfig from '../../../../../shared/config/addressFieldsConfig';

export default {
  field: {
    name: 'address',
    component: AddressEditor,
    label: 'checkout.lib.components.common.contact.field.address',
    required: true,
    fieldsConfig: addressFieldsConfig,
  },
};
